import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import NewRequestForm from './NewRequestForm';

function AddTask({ 
    handleAddRequest, 
    permissions, 
    setModalState, 
    folders = [],
    users = []
}) {
    const { t } = useTranslation();
    const hasAddPermissionInAnyCategory = () => {
        if (!permissions || !permissions.categories) {
            return false;
        }

        for (const categoryPermissions of Object.values(permissions.categories)) {
            if (categoryPermissions["IR"] && categoryPermissions["IR"].includes("Create")) {
                return true;
            }
        }

        return false;
    };

    const handleAddTaskClick = useCallback(() => {
        setModalState(prevState => {
            // Si la modal est déjà dans l'état souhaité, ne pas modifier
            if (
                prevState.isOpen &&
                prevState.title === t('pages.qa.createTask') &&
                prevState.fullscreen === false
            ) {
                return prevState;
            }

            // Sinon, mettre à jour l'état
            return {
                title: t('pages.qa.createTask'),
                content: (
                    <NewRequestForm 
                        onSubmit={handleAddRequest}
                        folders={folders}
                        users={users}
                    />
                ),
                isOpen: true,
                fullscreen: false,
                centered: true
            };
        });
    }, [setModalState, handleAddRequest, folders, users, t]);

    if (!hasAddPermissionInAnyCategory()) {
        return null;
    }

    return (
        <button 
            className="btn-add-task" 
            onClick={handleAddTaskClick}
            type="button"
        >
            <i className="bi bi-plus-square icon-spacing"></i> {t('pages.qa.createTask')}
        </button>
    );
}

export default AddTask;